import { useEffect } from 'react';
import { getGuias, guiaApto } from '../lib/guiasAgenciasStorage';
import { getGuiaRankingRows } from '../lib/guiaRanking';

const MESSAGE_TYPE = 'naviex-guias-list-export';

/**
 * Página pública (sem login) usada pelo cliente em iframe para obter a lista de guias ativos.
 * Quando cliente e admin rodam em origens diferentes (ex.: localhost:3000 vs 3002).
 * Envia os dados via postMessage para window.parent.
 */
export default function GuiasListExportPage() {
  useEffect(() => {
    try {
      const guias = getGuias();
      const ativos = guias.filter(guiaApto);
      const rankingMensal = getGuiaRankingRows('mensal');
      const rankingAnual = getGuiaRankingRows('anual');

      const guiasExport = ativos.map((g) => {
        const rankMensal = rankingMensal.find((row) => row.guiaId === g.id);
        const rankAnual = rankingAnual.find((row) => row.guiaId === g.id);
        const diasTrabalhados = rankMensal?.diasTrabalhados ?? rankAnual?.diasTrabalhados ?? 0;
        return {
          id: g.id,
          nome: g.nome,
          email: g.email,
          telefone: g.telefone,
          imagemPerfil: g.imagemPerfil,
          fotosTrabalhoGuia: g.fotosTrabalhoGuia,
          notaAvaliacao: g.notaAvaliacao,
          resumoPerfil: g.resumoPerfil,
          guidedToursCount: diasTrabalhados,
        };
      });

      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, guias: guiasExport }, '*');
      }
    } catch (err) {
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, guias: [], error: String(err) }, '*');
      }
    }
  }, []);

  return (
    <div className="p-4 text-sm text-gray-500">
      Lista de guias enviada.
    </div>
  );
}

export { MESSAGE_TYPE };
